import Container from "@/components/editorial/Container";
import Eyebrow from "@/components/editorial/Eyebrow";
import NewsletterForm from "@/components/editorial/NewsletterForm";

export default function FinalNewsletter() {
  return (
    <section
      data-testid="final-newsletter"
      className="relative overflow-hidden bg-charcoal text-cream py-24 md:py-36"
    >
      {/* Subtle warm gradient overlay */}
      <div
        aria-hidden="true"
        className="absolute inset-0 pointer-events-none opacity-80"
        style={{
          background:
            "radial-gradient(1200px 600px at 80% 120%, rgba(198,93,59,0.35), transparent 60%), radial-gradient(900px 500px at 10% 0%, rgba(201,169,97,0.18), transparent 60%)",
        }}
      />
      <Container className="relative z-10">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-7">
            <Eyebrow tone="gold" className="mb-5">
              Newsletter mensual
            </Eyebrow>
            <h2 className="font-serif font-light leading-[1.05] tracking-tight text-[clamp(2.5rem,5vw,4.5rem)]">
              Historias nuevas cada<br />
              <span className="italic">mes en tu bandeja.</span>
            </h2>
            <p className="mt-6 text-cream/80 text-lg max-w-xl">
              Sin spam. Solo las historias, eventos y aperturas que importan.
            </p>
            <p className="mt-6 text-cream/50 text-xs uppercase tracking-[0.22em]">
              Gracias a nuestros{" "}
              <a
                href="/for-brands#tiers"
                className="text-gold hover:text-cream transition-colors"
              >
                Founding Partners
              </a>{" "}
              por hacer posible Mujeres Motor.
            </p>
          </div>
          <div className="lg:col-span-5">
            <NewsletterForm variant="inline" tone="dark" testidPrefix="final-nl" />
          </div>
        </div>
      </Container>
    </section>
  );
}
